var map = {
  "./assets/favicons-prodaus1/android-chrome-192x192.png": "31141",
  "./assets/favicons-prodaus1/android-chrome-512x512.png": "92885",
  "./assets/favicons-prodaus1/apple-touch-icon.png": "7850",
  "./assets/favicons-prodaus1/browserconfig.xml": "81548",
  "./assets/favicons-prodaus1/favicon-16x16.png": "24901",
  "./assets/favicons-prodaus1/favicon-32x32.png": "75029",
  "./assets/favicons-prodaus1/favicon-alert-16x16.png": "46276",
  "./assets/favicons-prodaus1/favicon-alert-32x32.png": "56192",
  "./assets/favicons-prodaus1/favicon-alert.ico": "63167",
  "./assets/favicons-prodaus1/favicon.ico": "85942",
  "./assets/favicons-prodaus1/mstile-150x150.png": "35613",
  "./assets/favicons-prodaus1/site.webmanifest": "49659",
  "./assets/favicons-prodaus1/upc-favicon.ico": "58247"
};


function __rspack_context_module(req) {
  var id = __rspack_context_module_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_module_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context_module.keys = () => (Object.keys(map));
__rspack_context_module.resolve = __rspack_context_module_resolve;
module.exports = __rspack_context_module;
__rspack_context_module.id = 37076;
